// dependencies.
import { get } from 'lodash'

// detect the base URL.
const URL_LOADING_PAGE_PROFESSIONAL = get(process.env, 'URL_LOADING_PAGE_PROFESSIONAL')

/**
 * detect the api base URL
 */
export default URL_LOADING_PAGE_PROFESSIONAL



// WEBPACK FOOTER //
// ./src/plugins/http/url_professional.js